import { fetchPayload, update } from "../../../utils/reducerOperations";
import { Default } from "./InitialState";
import {
  RENDER_PDF_INIT,
  RENDER_PDF_LOAD_STARTED,
  RENDER_PDF_LOAD_SUCCESS,
  RENDER_PDF_LOAD_FAILED,
  RENDER_PDF_SET_VALUE_AT_PATH,
  RENDER_PDF_SAVE_STARTED,
  RENDER_PDF_SAVE_SUCCESS,
  RENDER_PDF_SAVE_FAILED,
  RENDER_PDF_RESET,
  FETCH_PDF_DATA_STARTED,
  FETCH_PDF_DATA_SUCCESS,
  FETCH_PDF_DATA_FAILED,
} from "../../constants";
import {
  initReportData,
  loadReportDataStarted,
  loadReportDataSuccess,
  loadReportDataFailed,
  setValueAtPath,
  saveReportDataStarted,
  saveReportDataSuccess,
  saveReportDataFailed,
  resetReportData,
  fetchPdfDataStarted,
  fetchPdfDataSuccess,
  fetchPdfDataFailed,
} from "./Helpers";

const renderPdfReducer = (state = Default(), action) => {
  let payload = fetchPayload(action);
  switch (action.type) {
    case RENDER_PDF_INIT:
      return update(state, initReportData(state, payload));
    case RENDER_PDF_LOAD_STARTED:
      return update(state, loadReportDataStarted(state, payload));
    case RENDER_PDF_LOAD_SUCCESS:
      return update(state, loadReportDataSuccess(state, payload));
    case RENDER_PDF_LOAD_FAILED:
      return update(state, loadReportDataFailed(state, payload));


    case FETCH_PDF_DATA_STARTED:
      return update(state, fetchPdfDataStarted(state, payload));
    case FETCH_PDF_DATA_SUCCESS:
      return update(state, fetchPdfDataSuccess(state, payload));
    case FETCH_PDF_DATA_FAILED:
      return update(state, fetchPdfDataFailed(state, payload));

    default:
      return setValueSaveReset(state, action);
  }
};

const setValueSaveReset = (state, action) => {
  let payload = fetchPayload(action);
  switch (action.type) {
    case RENDER_PDF_SET_VALUE_AT_PATH:
      return update(state, setValueAtPath(state, payload));
    case RENDER_PDF_SAVE_STARTED:
      return update(state, saveReportDataStarted(state, payload));
    case RENDER_PDF_SAVE_SUCCESS:
      return update(state, saveReportDataSuccess(state, payload));
    case RENDER_PDF_SAVE_FAILED:
      return update(state, saveReportDataFailed(state, payload));
    case RENDER_PDF_RESET:
      return update(state, resetReportData(state, payload));
    default:
      return state;
  }
};

export default renderPdfReducer;
